import pickBy from 'utils/pickBy';

// Identity/structure keys of a placeholder. They are read directly from the
// placeholder, never supplied by a style or an override — notably a style object
// carries `type` (the style category, e.g. 'text'), which is unrelated to the
// placeholder kind. Shared so the Polotno spec extraction and the getOriginalPage
// style merge agree on one boundary.
export const PLACEHOLDER_IDENTITY_KEYS = ['data', 'id', 'override', 'type'];

// Keep only defined (non-null) values: a missing value means "don't change",
// not "reset to default". The single definition of this rule for every spec merge.
export const pickDefined = (spec) => pickBy(spec, (value) => value != null);

// The visual contribution of a style: its defined, non-identity values.
const getStyleSpec = (style) =>
  pickBy(style, (value, key) => value != null && !PLACEHOLDER_IDENTITY_KEYS.includes(key));

// Canonical precedence: a style overrides the base, but only where it actually
// defines a value and never for identity keys. The single source of truth for
// style-over-base, used by both the DOM path (getOriginalPage) and the Polotno
// converter (mergeSpec), so the two engines can never drift apart.
export const mergeStyleOverBase = (base, style) => ({ ...base, ...getStyleSpec(style) });
